<template>
  <li class="sort">
    <a class="sort-list-btn" href="#" title="排序">
      <span>SORT</span>
      <i class="icon-sort" />
    </a>
    <div class="sub-list-block down-center">
      <ol class="sub-list">
        <li :class="{ selected: selectedMode === 1 }"><a :href="newToOld">NEWEST IN</a></li>
        <li :class="{ selected: selectedMode === 4 }">
          <a :href="lowToHigh">PRICE: LOW TO HIGH</a>
        </li>
        <li :class="{ selected: selectedMode === 3 }">
          <a :href="highToLow">PRICE: HIGH TO LOW</a>
        </li>
        <li :class="{ selected: selectedMode === 5 }">
          <a :href="hottest">BEST SELLERS</a>
        </li>
      </ol>
    </div>
  </li>
</template>

<script>
export default {
  data() {
    return {
      searchLocation: window.location.search,
      keyStr: 'OM=',
      selectedMode: null,
    };
  },
  computed: {
    lowToHigh() {
      return this.locationSearchFilter(4);
    },
    highToLow() {
      return this.locationSearchFilter(3);
    },
    newToOld() {
      return this.locationSearchFilter(1);
    },
    hottest() {
      return this.locationSearchFilter(5);
    },
  },
  created() {
    this.selectedMode = this.getOrderMode();
  },
  methods: {
    getOrderMode() {
      const args = this.searchLocation.split('&');
      let ModeStr = '';

      for (let i = 0; i < args.length; i++) {
        if (args[i].indexOf('OM') !== -1) {
          ModeStr = args[i];
        }
      }

      let mode = null;

      if (window.location.pathname === '/recent' && ModeStr.length === 0) {
        mode = 1;
      } else if (window.location.pathname === '/hot' && ModeStr.length === 0) {
        mode = 5;
      } else if (window.location.pathname === '/favorite' && ModeStr.length === 0) {
        mode = null;
      } else if (ModeStr.length === 0) {
        mode = 1;
      } else {
        mode = parseInt(ModeStr.charAt(ModeStr.length - 1));
      }
      return mode;
    },
    locationSearchFilter(orderNum) {
      let argsString = '';
      if (window.location.toString().indexOf('?') !== -1) {
        const args = window.location.toString().split('?')[1].split('&');

        let i = 0;
        while (i < args.length) {
          if (args[i].indexOf('OM') !== -1) {
            args.splice(i, 1);
          } else if (args[i].indexOf('P=') !== -1) {
            args.splice(i, 1);
          } else {
            i += 1;
          }
        }

        if (args.length !== 0) {
          // 存在其他條件參數
          argsString = `${args.join('&')}&`;
        } else {
          argsString = `${args.join('&')}`;
        }
      }

      return `?${argsString}${this.keyStr}${orderNum}`;
    },
  },
};
</script>
